<div *ngIf="content" class="content-with-optional-title mb-2">
    <h2 *ngIf="title">{{ title | translate }}</h2>
    <p *ngIf="hasInnerHtml" [innerHtml]="content"></p>
    <p *ngIf="!hasInnerHtml"><span lang='{{ lang }} '>{{content}}</span></p>
</div>